"use strict";

import RegionPageEntryPoint from './entry';
import payload from 'ofs/payload';

var entry = new RegionPageEntryPoint(payload);

if (__BROWSER__) {
  entry.render(document);
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/homepage/init.jsx
 **/